import { api } from '@src/api/api'
import { UserType } from '@src/types/user'
import { NewUserData } from '@src/store/ducks/auth/types'

export type RegisterPhone = {
  phone: string
}

export const authApi = {
  register(phone: string, uid: any, systemName: any) {
    return api.post<{ message: string }>('/v1/auth/register', { phone, uid, systemName })
  },
  login(username: string, passwd: string) {
    return api.post<{ userInfo: UserType }>('/v1/auth/login', { username, passwd })
  },
  logout() {
    return api.post('/v1/auth/logout')
  },
  changePassword(data: { oldPassword: string, password: string, account: string }) {
    return api.post('/v1/user/change-password', data)
  },
  recallPassword(account: string, phone: string) {
    return api.post<string>('/v1/user/recall-password', { account, phone })
  },
  recallPasswordByPassport(account: string, passport: string) {
    return api.post<NewUserData>('/v1/user/recall-password-by-passport', { account, passport })
  },
}
